import {useEffect, useState} from "react";

export default function useDelayedMount(isMounted: boolean, delay: number) {
    const [shouldRender, setShouldRender] = useState(false);

    useEffect(() => {
        let timeoutId: NodeJS.Timeout;
        if (isMounted && !shouldRender) {
            setShouldRender(true);
        } else if (!isMounted && shouldRender) {
            timeoutId = setTimeout(
                () => {
                    setShouldRender(false)
                },
                delay,
            );
        }

        return () => clearTimeout(timeoutId);
    }, [isMounted, delay, shouldRender]);

    return shouldRender;
}
